import styled, { css, keyframes } from "styled-components";
import { useEffect, useState } from 'react'
import { CheckCircleTwoTone } from '@ant-design/icons';

export const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

export const Wrapper = styled.div`
  & .header-banner {
    height: 200px;
    transform: translateY(-1px);
  }
`;

export const ContentSection = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 44px;
  /* background: #F3F6FA; */
`;

export const BioDetailStyle = css`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #A9ACC0;
  display: flex;
  align-items: center;
  .empty {
    span {
      text-decoration: none;
      color: #E3E7ED;
    }
  }
`;

export const Achievements = styled.div`
  width: 775px;
  display: flex;
  flex-direction: column;
  margin-top: 64px;
  .header-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: #1D1E2B;
    margin-bottom: 27px;
    .header-title-tooltip {
      font-family: 'Lato';
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      color: #464ac9;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .category-button-group {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  & .description {
    margin-top: 16px;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #A9ACC0;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
`;

const BioIconContentDefault = css`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
`;

export const BioIconContent = styled.div`
  ${BioIconContentDefault}
  border-radius: 50%;
  background: #E3E7ED;
`;

export const URLIcon = styled.div`
  ${BioIconContentDefault}
  & .url-icon {
    width: 100%;
  }
`;

export const BioContent = styled.div`
  display: flex;
  flex-direction: column;
  & p {
    margin-bottom: 0px;
  }
  & .content {
    color: #1D1E2B;
  }
  & .ant-btn-link {
    padding: 0px;
    height: 16px;
    display: flex;
    span {
      text-decoration: underline;
      font-size: 12px;
      max-width: 230px;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
`;

export const AchievementsList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`;

export const Empty = styled.div`
  width: 100%;
  display: flex;
  height: 435px;
  margin-top: 8px;
  flex-direction: column;
  align-items: center;
  .empty-icon {
    width: 120px;
    height: 87px;
    margin-top: 90px;
  }
  .title {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #1D1E2B;
    margin-top: 40px;
    margin-bottom: 12px;
  }
  .description {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #73747D;
  }
  background: white;
  border: 1px solid #E3E7ED;
  box-shadow: 0px 6px 10px -1px rgba(29, 30, 43, 0.07);
  border-radius: 8px;
`;

export const LeftSectionTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: black;
`;

export const LeftSection = styled.section`
  ${ContentSection}
  background: #F3F6FA;
  width: 27%;
  max-width: 332px;
`;

export const RightSection = styled.section`
  ${ContentSection}
  flex: 1 auto;
`;

export const ContentContainer = styled.div`
  display: flex;
  width: 100%;
`;


export const AvatarContainer = styled.div`
  left: 80px;
  position: absolute;
  bottom: 0px;
  transform: translateY(50%);
  & .default-avatar-container  {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: transparent;
    border: 5px solid #cbcbcb70;
    box-shadow: 0px 4.21053px 14.0351px rgba(185, 185, 185, 0.25);
    /* &:hover {
      cursor: pointer;
      transform: rotate(666turn);
      transition: all 59s cubic-bezier(.34,0,.84,1) 1s;
    } */
  }
`;

export const Name = styled.div`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #1D1E2B;
  margin-top: 120px;
  position: relative;
  width: 100%;
`;

export const Bio = styled.div`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #1D1E2B;
  margin-top: 8px;
  &.empty {
    color: #A9ACC0;
  }
`;

export const PreferredName = styled.div`
  ${BioDetailStyle}
  margin-bottom: 8px;
  width: 100%;
`;
export const Location = styled.div`
  ${BioDetailStyle}
  margin-bottom: 8px;
`;
export const AppCycle = styled.div`
  ${BioDetailStyle}
`;

export const Linkedin = styled.div`
  ${BioDetailStyle}
  margin-bottom: 20px;
`;
export const Instagram = styled.div`
  ${BioDetailStyle}
  margin-bottom: 20px;
`;
export const TikTok = styled.div`
  ${BioDetailStyle}
  margin-bottom: 20px;
`;
export const MyHomepage = styled.div`
  ${BioDetailStyle}
  margin-bottom: 20px;
`;
export const Portfolio = styled.div`
  ${BioDetailStyle}
`;


export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

export type ProfileProps = {
  avatarSrc: string;
  avatarName: string
  currentUser: {
    applicationYear: string;
    betaSupporter: string;
    city: string;
    country: string;
    coverPhoto: string;
    description: string;
    email: string;
    firstName: string;
    id: string;
    lastName: string;
    name: string;
    primaryRole: string;
    profilePhoto: string;
    profileSign: string;
    pronoun: string;
    role: string;
    specialties: string;
    timezone: string;
    website: string;
  };
  match: {
    params: {
      userId: string;
    }
  }
};

export const AboutMe = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 55px;
`;

export const AboutTitle = styled.div`
  height: 29px;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #1D1E2B;
`;

export const AboutMeColumns = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;


export const AboutMeColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 381px;
`;

export const AboutMeItems = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  .title {
    height: 15px;
    font-family: 'Lato';
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    color: #A9ACC0;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    & .anticon-check-circle {
      display: flex;
      align-items: center;
    }
  }
  .empty-content {
    color: #E3E7ED;
  }
  & .ant-input {
    padding-left: 0px;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #1D1E2B;
  }
`;


export type ProfileURLs = {
  linkedin: string;
  instagram: string;
  tiktok: string;
  homepage: string;
  portfolio: string;
  id: string;
  userId: string;
}

export const StyledCheckCircleTwoTone = styled(CheckCircleTwoTone)`
  -webkit-animation: ${fadeOut} 1s ease-out both;
  animation: ${fadeOut} 1s ease-out both;
  width: 20px;
  height: 20px;
`;


export type AboutMeTypes = {
  id?: string;
  hobbies: string;
  intendedMajors: string;
  bookIlove: string;
  favoriteFoods: string;
  favoriteHolidays: string;
  musicRecommendations: string;
  funFact: string;
  superpower: string;
  meaningOfName: string;
  userId: string;
}

export function useDebounce<T>(value: T, delay?: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay || 500)

    return () => {
      clearTimeout(timer)
    }
  }, [value, delay])

  return debouncedValue
}


export enum Categories {
  ACADEMICS = 'ACADEMICS',
  SAT = 'SAT',
  ACTIVITIES = 'ACTIVITIES',
  COMPETITIONS_HONORS = 'COMPETITIONS_HONORS',
  PERSONAL_DEVELOPMENT = 'PERSONAL_DEVELOPMENT',
  CAREERS = 'CAREERS',
  TEST = 'TEST',
}

export enum Subcategories {
  School_Academic = 'School Academics',
  University_Programs = 'University Courses & Summer Programs',
  Research = 'Academic Research & Publications',
  Portfolios = 'Creative Portfolios',
  Internship_Experience = 'Internship & Work Experience',
  Extracurricular_Activities = 'Extracurricular Activities',
  Competitions_Honor = 'Competitions Honor',
  Reading = 'Readings',
  Writing = 'Writings',
  Essential = 'Essential Skills & Experiences',
  Relationship = 'Relationship Building',
  Preparation = 'School Research & Preparation',
  Major = 'Major, Career and Interest Exploration',
  Networking = 'Networking',
  Honor = 'Competitions & Honors',
  Academic_Skill = 'Academic Skills & Essential Experiences',
  Subject_Interest = 'Subject Interest Development',
  NAY = 'UK Non-Application Year (NAY) Curriculum',
  NAY_UK = 'NAY Curriculum/UK Candidacy Building',
}

export type ExtracurricularItem = {
  title: string;
  id: string;
  description: string;
  extracurricular: {
    id: string;
    subType: string;
    activityType: string;
    organizationName: string;
    position: string;
    hoursPerWeek: number;
    weeksPerYear: number;
    description: string;
  }
}

export type ExperienceItem = {
  title: string;
  id: string;
  description: string;
  experience: {
    id: string;
    industry: string;
    organizationName: string;
    programProvider: string;
    position: string;
    applicationDeadline: string;
    impactFactor: string;
  }
}

export type ProgramItem = {
  title: string;
  id: string;
  description: string;
  program: {
    id: string;
    type: string;
    resourceCategoryName: string;
  }
}

export type ResearchItem = {
  title: string;
  id: string;
  description: string;
  research: {
    id: string;
    provider: string;
    field: string;
    subField: string;
    criProgram: string;
  }
}

export type HonorItem = {
  title: string;
  id: string;
  description: string;
  honor: {
    id: string;
    category: string;
    award: string;
    awardLevel: string;
    schoolYear: Array<string>;
    levelOfRecognition: string;
  }
}

export const AchievementCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 32px;
  background: white;
  border: 1px solid #E3E7ED;
  box-shadow: 0px 1px 2px rgba(184, 200, 224, 0.2);
  border-radius: 8px;
  margin-bottom: 20px;
  & .title {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #1D1E2B;
    margin-bottom: 12px;
  }
  & .description {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #73747D;
    margin-bottom: 16px;
    white-space: pre-line;
  }
  & .tags {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 8px;
    .supported-link {
      margin-left: auto;
      display: flex;
      align-items: center;
      .link {
        color: #464AC9;
        text-decoration: underline;
        margin-left: 2px;
        cursor: pointer;
      }
      .supported-icon {
        height: 16px;
        width: 16px;
        margin-right: 6px;
      }
    }
    
    & .ant-tag {
      color: #464AC9;
      display: flex;
      align-items: center;
      padding: 4px 16px;
      height: 24px;
      background: #F4F5FF;
      border-radius: 20px;
      border: 0px;
    }
  }
  &.unvisible {
    background: #F8F8F8;
    & .ant-tag{
      background: white;
      border: 0px;
    }
  }
  .achievements-footer {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 12px;
    .add-reaction {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
    .MuiSvgIcon-root {
      cursor: pointer;
    }
    .emoji-container {
      max-height: 26px;
      display: flex;
      align-items: center;
      cursor: pointer;
      background: #F3F6FA;
      border-radius: 20px;
      padding: 2px 10px;
      font-family: 'Lato';
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      margin-right: 8px;
      border: 1px solid #F3F6FA;
      &.invisible {
        display: none;
      }
      &:hover {
        border: 1px solid #73747D;
      }
      &.active {
        border: 1px solid #464AC9;
        background: #F4F5FF;
        &:hover {
          border: 1px solid #F3F6FA;
        }
      }
      .emoji {
        line-height: 20px;
        font-size: 20px;
        margin-right: 6px;
      }
    }
  }
`;

export const exceptEmojis = [
  'zany_face',
  'stuck_out_tongue_winking_eye',
  'sleeping',
  'melting_face',
  'upside_down_face',
  'slightly_smiling_face',
  'middle_finger',
  'money_mouth_face',
  'hugging_face',
  'face_with_hand_over_mouth',
  'face_with_open_eyes_and_hand_over_mouth',
  'face_with_peeking_eye',
  'shushing_face',
  'thinking_face',
  'zipper_mouth_face',
  'face_with_raised_eyebrow',
  'neutral_face',
  'expressionless',
  'no_mouth',
  'dotted_line_face',
  'face_in_clouds',
  'smirk',
  'unamused',
  'face_with_rolling_eyes',
  'grimacing',
  'face_exhaling',
  'lying_face',
  'relieved',
  'pensive',
  'sleepy',
  'drooling_face',
  'mask',
  'face_with_thermometer',
  'face_with_head_bandage',
  'nauseated_face',
  'face_vomiting',
  'sneezing_face',
  'hot_face',
  'cold_face',
  'woozy_face',
  'dizzy_face',
  'face_with_spiral_eyes',
  'disguised_face',
  'sunglasses',
  'nerd_face',
  'face_with_monocle',
  'confused',
  'face_with_diagonal_mouth',
  'worried',
  'slightly_frowning_face',
  'white_frowning_face',
  'open_mouth',
  'hushed',
  'astonished',
  'flushed',
  'pleading_face',
  'face_holding_back_tears',
  'frowning',
  'anguished',
  'fearful',
  'cold_sweat',
  'disappointed_relieved',
  'cry',
  'sob',
  'scream',
  'confounded',
  'persevere',
  'disappointed',
  'sweat',
  'weary',
  'tired_face',
  'yawning_face',
  'triumph',
  'rage',
  'angry',
  'face_with_symbols_on_mouth',
  'smiling_imp',
  'imp',
  'skull',
  'skull_and_crossbones',
  'hankey',
  'clown_face',
  'japanese_ogre',
  'japanese_goblin',
  'ghost',
  'alien',
]

export const aboutListLeft: Array<{
  key: keyof AboutMeTypes;
  title: string;
}> = [{
  key: 'intendedMajors',
  title: 'Intended Majors ',
}, {
  key: 'favoriteFoods',
  title: 'My favorite foods',
}, {
  key: 'musicRecommendations',
  title: 'Music recommendations',
}, {
  key: 'superpower',
  title: 'If I had a superpower, what would it be?',
}, {
  key: 'meaningOfName',
  title: 'The meaning of my name',
}];
export const aboutListRight: Array<{
  key: keyof AboutMeTypes;
  title: string;
}> = [{
  key: 'hobbies',
  title: 'My Hobbies',
}, {
  key: 'bookIlove',
  title: 'A book I love',
}, {
  key: 'favoriteHolidays',
  title: 'My favorite holidays',
}, {
  key: 'funFact',
  title: 'A fun fact about me',
}];


export type ItemType = {
  userId: string;
  userName: string;
}

export type EmojisListType = {
  [key: string]: Array<ItemType>;
}

export type AchievementItemType = {
  id?: string;
  achievementId: string;
  userId: string;
  emojisList: EmojisListType;
}

export function updateEmojiListByAchievementId(achievements: Array<AchievementType>, achievementId: string, emojisList: EmojisListType): Array<AchievementType> {
  const index = achievements.findIndex((item) => item.id === achievementId);
  if (index !== -1) {
    achievements[index] = { ...achievements[index], emojisList: achievements[index]?.emojisList ? { ...achievements[index]?.emojisList, ...emojisList } : emojisList };
  }
  return index !== -1 ? [...achievements] : achievements;
}

export type AchievementType = {
  id: string;
  title: string;
  description: string;
  tags: Array<string>;
  supporteBy: string;
  emojisList: EmojisListType;
  visibleToOthers?: boolean;
  likes?: Array<ItemType>;
}

export function getEmojiDataForAchievement({
  achievementId,
  achievements
}: {
  achievementId: string;
  achievements: Array<AchievementItemType>;
}): AchievementItemType & {
  visibleToOthers: boolean;
  likes: Array<ItemType>;
} {
  const { id, ...rest } = achievements.find((item) => item.achievementId === achievementId) || { id: '' };
  return {
    achievementId,
    userId: '',
    emojisList: {},
    visibleToOthers: false,
    likes: [],
    ...rest,
  };
}

export function getEmojiListContainsUserId({
  userId,
  emojisList,
}: {
  userId?: string;
  emojisList: EmojisListType;
}): Array<string> {
  if (!userId) {
    return [];
  }
  return Object.keys(emojisList).map(key => {
    if (emojisList[key].findIndex((item) => item.userId === userId) !== -1) {
      return key;
    }
  }).filter(item => item) as Array<string>;
}

export const getTailCharS = (num: number, staticString: string): string => {
  return num === 1 ? `${num} ${staticString}` : `${num} ${staticString}s`;
};

export const EMPTY_VALUE = {
  toBeDefined: 'To be defined',
  enter: 'Enter',
  bio: 'Add a bio to get others know about you.',
}

export function getDisplayValue(value?: string, emptyValue: string = EMPTY_VALUE.toBeDefined) {
  return value ? value : emptyValue;
}